export default "__VITE_ASSET__DUplFQtX__"